module.exports = __webpack_public_path__ + "public/img/spaceManage.2ca48731.png";